<template>
  <hamv-dialog
    :dialogProps="dialogProps"
    :showModal="showModal"
    infinite-scroll-disabled="infiniteScrollDisabled"
    infinite-scroll-distance="20"
    infinite-scroll-immediate-check="true"
    v-infinite-scroll="infiniteScrollCallback"
  >
    <el-row class="el-dialog__title" data-qa="Dialog-TimelineModel-Header" slot="header">
      <el-col :span="8" data-qa="Dialog-TimelineModel-Title">{{ $t('timelineComponentTitle') }}</el-col>
      <el-col :span="6" class="type-filter" v-if="showEventFilter">
      <el-select
        :label="$t('timelineFilterPlaceholder')"
        @change="changeFilterType"
        data-qa="Dialog-TimelineModel-Filter-Select"
        v-model="filterType">
        <el-option
          v-for="item in headerSelectFilter"
          :data-qa="item.dataQA"
          :key="item.text"
          :label="$t(item.text)"
          :value="item.value">
        </el-option>
      </el-select>
      </el-col>
    </el-row>
    <div data-qa="Dialog-TimelineModel-Body" v-loading="isLoading">
      <timeline-log :log-list="lists" :fields="fields"></timeline-log>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './TimelineModel.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './TimelineModel.scss'
</style>



// WEBPACK FOOTER //
// TimelineModel.vue?12765c5e